// src/util/AppUtil.js
import { DefaultRule } from "../value/AppConst";

const STORAGE_KEY = "simRuleIgnoLab";

export default class AppUtil {
    static readRuleStored() {
        // 로컬 스토리지에서 규칙을 읽어오는 로직. 로컬 스토리지에 저장된 규칙이 없으면 기본값을 사용
        const storedRule = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if(storedRule) return storedRule;

        // get only DefaultRule.someKey.default
        return Object.fromEntries(
            Object.entries(DefaultRule).map(([key, value]) => [key, value.default])
        );
    }

    static saveRuleInLocalStorage(rule) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(rule));
    }

    static readStockData(tsvText) {
        const data = []; // { date, open, high, low, close, volume, rollingHigh }

        const lines = tsvText.trim().split("\n");
        for (const line of lines) {
            if(/^\d{4}/.test(line)) {
                const [date, open, high, low, close, volume] = line.split("\t").map(item => {
                    if(item) {
                        item = item.replace(/,/g, ""); // remove commas
                    }
                    return item;
                });
                if (!date || !open || !high || !low || !close || !volume) continue;
                const [year, month, day, etc] = date.split(/\D+/, 4); // etc for time part to dump

                const ymd = year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
                const rec = {
                    date: ymd,
                    open: parseFloat(open),
                    high: parseFloat(high),
                    low: parseFloat(low),
                    close: parseFloat(close),
                    volume: parseInt(volume, 10),
                    rollingHigh: 0,
                    error: null
                };

                if(rec.high < rec.low || rec.open < rec.low || rec.close < rec.low || rec.open > rec.high || rec.close > rec.high) {
                    rec.error = "데이터 오류";
                }
                data.push(rec);
            }
            else if(/^\w/.test(line)) {
                const [date, open, high, low, close, volume] = line.split("\t");
                if(date !== 'Date' || open !== 'Open' || high !== 'High' || low !== 'Low' || close !== 'Close' || volume !== 'Volume') {
                    throw new Error("헤더 오류: " + line);
                }
            }
        }

        return data;
    }
}

/*
Perl Script to parse TSV data

###
sub readStockData {
    my $rollingHighPeriod = shift; # 롤링 최고가 기간
    my %data;
    while(<DATA>) {
        chomp;
        if(/^\d{4}/) {
            my($date, $open, $high, $low, $close, $volume) = map {s/,//g; $_} split /\t/, $_;

            if($high < $low || $open < $low || $close < $low || $open > $high || $close > $high) {
                die "Invalid stock data: $_";
            }
            my($year, $month, $day) = $date =~ /(\d{4})\D+(\d+)\D+(\d+)/;
            $date = sprintf("%04d-%02d-%02d", $year, $month, $day);
            $data{$date} = {
                open => $open,
                high => $high,
                low => $low,
                close => $close,
                volume => $volume,
                rollingHigh => 0,
            };
        }
        elsif(/^\w/) {
            my($date, $open, $high, $low, $close, $volume) = split /\t/, $_;
            if($date ne 'Date' || $open ne 'Open' || $high ne 'High' || $low ne 'Low' || $close ne 'Close' || $volume ne 'Volume') {
                die "Invalid header: $_";
            }
        }
    }
    # 롤링 최고가 계산
    my @dates = sort keys %data;
    foreach my $i (0..$#dates) {
        if($i >= $rollingHighPeriod - 1 && $rollingHighPeriod > 0) {
            # close 가격의 롤링 최고가를 계산
            my $min = $i - $rollingHighPeriod + 1;
            my $high = 0;
            foreach my $k ($min..$i) {
                my $date = $dates[$k];
                if($data{$date}->{close} > $high) {
                    $high = $data{$date}->{close};
                }
            }
            $data{$dates[$i]}->{rollingHigh} = $high;
        }
    }
    \%data;
}


*/